
import { Box, Flex, SimpleGrid, Image, Text, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useEffect, useState } from 'react';
import Banner from 'views/admin/main/ecommerce/overviewProduct/components/Banner';

import SearchTableOrders from 'views/admin/main/ERP/AgendaActividades/RegistroActividades/components/SearchTableOrders';
import tableDataOrders from 'views/admin/main/ecommerce/orderList/variable/tableDataOrders';
import CasillasGrafico from 'views/admin/dashboards/default/components/CasillasGrafico';

export default function SearchUser() {
	type RowObj = {
		Anombre: string;
		id: number;
		fechahora: string;
		updatedAt: string;
		Mesa: number;
		meserosId: number;
		Empresaid: number;
		PrecioTotal: string;
		createdAt: string;
		Estatus: boolean;
	};
	const { isOpen, onOpen, onClose } = useDisclosure()

	const [seccionx, setseccionx] = useState([]);
	const [eventox, seteventox] = useState('');

	const url = process.env.REACT_APP_URL_SERVER + '/evidencias';
	const [data, setData] = useState<any[]>([]);
	const [isLoading, setisLoading] = useState(true);


	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		try {
			const response = await fetch(url, { credentials: 'include' });
			const result = await response.json();
			setData(result);
			setisLoading(false)
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	return (
		<Flex direction='column' >

			<Modal isOpen={isOpen} onClose={onClose} size={'lg'}>
				<ModalOverlay />
				<ModalHeader>ID EVENTO: {eventox} EVIDENCIAS CARGADAS</ModalHeader>

				<ModalContent>
					<ModalHeader>Evento: #ID {eventox}</ModalHeader>
					<ModalCloseButton />

					<ModalBody>
						<SimpleGrid
							minChildWidth="150px"
							columns={4}
							spacing={10}
							maxW="xl"
							gap={25}
							alignItems="center"
							justifyContent="center"
							margin="100px auto"
						>
							{seccionx.map((turtle: any) =>
							(<Box key={turtle.id} w={'210px'} h={'200px'} paddingRight={20} backgroundImage={turtle.Imagen} backgroundSize={'cover'} position={'relative'} backgroundRepeat={'no-repeat'} display={'block'} onClick={() => {}}>
							</Box>)
							)}
						</SimpleGrid>
					</ModalBody>
					<ModalFooter>
						<Button colorScheme='blue' mr={3} onClick={() => {
							const url2 = process.env.REACT_APP_URL_SERVER + "/descargar_imagenes/" + eventox;
							window.location.replace(url2)
						}}>
							Descargar Imagenes
						</Button>
						<Button colorScheme='red' mr={3} onClick={onClose}>
							Cerrar
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>

			<SimpleGrid
				spacing={10}
				columns={5}
				minChildWidth="150px"
				pt={75}
				gap={65}
			>
				{data.filter(turtle => turtle.Evidencias?.length > 0).map(turtle =>
				(<Box
					key={turtle.id}
					w={'210px'}
					h={'200px'}
					paddingRight={20}
					backgroundImage={turtle.Evidencias[0].Imagen}
					backgroundSize={'cover'}
					position={'relative'}
					backgroundRepeat={'no-repeat'}
					display={'block'}
					borderRadius={'2xl'}
					onClick={() => {
						setseccionx(turtle.Evidencias)
						seteventox(turtle.id)
						onOpen();
					}}>
					<Box bgColor={'blackAlpha.500'} w='210px' borderTopRadius={'2xl'}>
						<Text fontWeight={'bold'} color={'white'} pl={3}>
							{turtle.Actividad}
						</Text>
						<Text fontWeight={'normal'} color={'white'} pl={2}>
							{turtle.Descripcion}
						</Text>
					</Box>
				</Box>)
				)}
			</SimpleGrid>
		</Flex>
	);
}
